import { render, staticRenderFns } from "./vuex-form-viewer.vue?vue&type=template&id=1b3a8622&scoped=true"
import script from "./vuex-form-viewer.vue?vue&type=script&lang=js"
export * from "./vuex-form-viewer.vue?vue&type=script&lang=js"
import style0 from "./vuex-form-viewer.vue?vue&type=style&index=0&id=1b3a8622&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a8622",
  null
  
)

export default component.exports